import $ from 'jquery'
/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
	if (!name) return;
	return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}

//公用弹框
export function funcCommonTankuang(info){
  $("#tipBox").html(info).show();
  setTimeout(function(){
    $("#tipBox").hide();
  },1500);
}

export function GetQueryString(name)
{
  let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  let r = window.location.search.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}

export function GetRequest(name) {
  var strs,r,str1;
  var url = location.search; //获取url中"?"符后的字串
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    strs = str.split("&");
    for(var i = 0; i < strs.length; i ++) {
      if(strs[i].split("=")[0] == name){
        if((strs[i].split("=")[1]) !="") r=(strs[i].split("=")[1])
        str1 = getCaption(r)
      }
    }
  }
  return str1;
}

export function getCaption(obj){
  if(obj.indexOf("\%3F") != -1){
    var index=obj.indexOf("\%3F");
    obj=obj.substring(0,index);
  }
  return obj;
}

export function isInWeiXin(){
  let ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  }else{
    return false;
  }
}

/*
 * 封装ajax方法
 * */
export function errAjax(url) {
  $.ajax({
    url: url,
    jsonp: "callback",
    dataType: "jsonp",
    success: function( response ) {
      console.log( response ); // server response
    }
  });
}

export function callback(){}



// WEBPACK FOOTER //
// ./src/utils/mUtils.js